var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKidsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2629_1113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1425 18.5C32.8059 15.6199 34.5257 11.7875 33.0415 9.20935C31.5573 6.6312 27.3285 6.25957 22.9702 7.9435C22.2634 3.37947 19.7662 0 16.786 0C13.8059 0 11.3086 3.37947 10.6019 7.9435C6.24354 6.25957 2.02655 6.70088 0.530577 9.29065C-0.965396 11.8804 0.766163 15.6664 4.42953 18.5813C0.766163 21.3801 -0.953617 25.2009 0.530577 27.7442C2.01477 30.2875 6.24354 30.7404 10.6019 29.0333C11.3086 33.5973 13.8059 36.9768 16.786 36.9768C19.7662 36.9768 22.2634 33.6786 22.9702 29.0333C27.3285 30.7172 31.5455 30.2643 33.0415 27.721C34.5375 25.1777 32.8059 21.3801 29.1425 18.5Z",
    fill: "#41B9C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2629_1113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsLogo);
export default __webpack_public_path__ + "static/media/kidsLogo.2a3d072ac4db2d928d8cf7dc66a2d6a7.svg";
export { ForwardRef as ReactComponent };